
/**
 * Simple in-memory cache for avatar URLs to reduce API calls
 */

interface AvatarCache {
  [avatarId: number]: {
    url: string;
    timestamp: number;
  };
}

// In-memory cache to store avatar URLs
const avatarCache: AvatarCache = {};

// Cache expiration time (in milliseconds) - 1 hour
const CACHE_EXPIRATION = 60 * 60 * 1000;

export const avatarCacheService = {
  /**
   * Get an avatar URL from cache if available
   */
  getFromCache: (avatarId: number): string | null => {
    const cachedAvatar = avatarCache[avatarId];
    
    if (!cachedAvatar) return null;
    
    // Check if cache is expired
    if (Date.now() - cachedAvatar.timestamp > CACHE_EXPIRATION) {
      delete avatarCache[avatarId];
      return null;
    }
    
    return cachedAvatar.url;
  },
  
  /**
   * Add an avatar URL to cache
   */
  addToCache: (avatarId: number, url: string): void => {
    avatarCache[avatarId] = {
      url,
      timestamp: Date.now()
    };
  },
  
  /**
   * Clear the entire cache or a specific avatar
   */
  clearCache: (avatarId?: number): void => {
    if (avatarId !== undefined) {
      delete avatarCache[avatarId];
    } else {
      Object.keys(avatarCache).forEach(key => {
        delete avatarCache[Number(key)];
      });
    }
  }
};
